import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ButtonModule } from "primeng/button";;
import { InputTextModule } from "primeng/inputtext";
import { TableModule } from 'primeng/table';
import { HttpClientModule } from "@angular/common/http";
import { DividerModule } from "primeng/divider";
import { ItemServicoListarComponent } from "./item-servico-listar.component";
import { MessagesModule } from "primeng/messages";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ItemServicoListarRoutingModule } from "./item-servico-listar-routing.module";
import { ConfirmationService } from "primeng/api";
import { FormsModule } from "@angular/forms";
import { DropdownModule } from "primeng/dropdown";
import { RippleModule } from "primeng/ripple";
import { TooltipModule } from "primeng/tooltip";

@NgModule({
    imports: [
    CommonModule,
    ItemServicoListarRoutingModule,
    FormsModule,
    ButtonModule,
    InputTextModule,
    TableModule,
    HttpClientModule,
    DividerModule,
    MessagesModule,
    ConfirmDialogModule,
    DropdownModule,
    RippleModule,
    TooltipModule
],
    providers: [ConfirmationService],
    declarations: [ItemServicoListarComponent]
})
export class ItemServicoListarModule { }
